// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"_2THdOiLLCnL9V44S4_24OR","ldsRing":"_2w-2LMiq9UAQEjeQdgNF0i","LoadingText":"_2bzYC8_tPx7FFPnXzZdUoa","small":"_3f91rqVdsdMTlB_jTfpbQf"};